import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.5833 6.94425L19.0558 5.41675L13 11.4726L6.94413 5.41675L5.41663 6.94425L11.4725 13.0001L5.41663 19.0559L6.94413 20.5834L13 14.5276L19.0558 20.5834L20.5833 19.0559L14.5275 13.0001L20.5833 6.94425Z",
		fill: "currentColor"
	})
});
export default SvgClose;
